import fetch from '@/utils/fetch'
// 獲取卡券包列表
export const packageList = (params) => {
  return fetch({
    url: '/voucher/package/list',
    method: 'get',
    params
  })
}

// 獲取優惠券列表
export const couponList = (params) => {
  return fetch({
    url: '/discountcard/list',
    method: 'get',
    params
  })
}

// 建立劵包
export const createdCoupons = (params) => {
  return fetch({
    url: '/voucher/package',
    method: 'post',
    params
  })
}
// 檢視卡劵包
export const couponDetail = (params) => {
  return fetch({
    url: '/voucher/package/details',
    method: 'get',
    params
  })
}

// 編輯卡劵包
export const editCouponPackage = (params) => {
  return fetch({
    url: '/voucher/package',
    method: 'patch',
    params
  })
}

// 刪除劵包
export const deleteCoupon = (params) => {
  return fetch({
    url: '/voucher/package',
    method: 'delete',
    params
  })
}

// 卡劵包領取日誌
export const couponLog = (params) => {
  return fetch({
    url: '/voucher/package/get_receives_log',
    method: 'get',
    params
  })
}

// 檢測包內優惠券等級限制，獲取不可領用的等級

export const checkCouponPackage = (params) => {
  return fetch({
    url: '/voucher/package/check_grade_limit',
    method: 'post',
    params
  })
}
